import { render } from "./Followers.vue?vue&type=template&id=4ec1ed5d&ts=true"
import script from "./Followers.vue?vue&type=script&lang=ts"
export * from "./Followers.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__